<div class="header">
    <div class="header__cont">
        <div class="container">
            <div class="row">
                <div *ngIf="localStorageService.get('authorized') !== null" class="hamburger-icon col-3 d-md-none"
                    (click)="onClickHamburger()">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div [ngClass]= 'localStorageService.get("authorized") === null? "col-6" : "col-7"'  class="header__logo col-md-2">       
                    <img src="/assets/images/atram_614x130.png"/>
                </div>
                <div *ngIf="localStorageService.get('authorized') !== null && router.url !== '/faq'" class="header__nav d-none d-md-block col-8">
                    <div class="container">
                        <div class="row">
                            <div class="col-3 header__tabs">
                                <p [class.active]="isRouterLinkActive('/file-upload/mutual-funds')" (click)="navigateUrl('/file-upload/mutual-funds')">
                                    Mutual Funds
                                </p>
                            </div>
                            <div class="col-2 header__tabs">
                                <p [class.active]="isRouterLinkActive('/file-upload/uitf')" (click)="navigateUrl('/file-upload/uitf')">
                                    UITF
                                </p>
                            </div>
                            <div class="col-3 header__tabs">
                                <p [class.active]="isRouterLinkActive('/file-upload/client-onboarding')" (click)="navigateUrl('/file-upload/client-onboarding')">
                                    Onboarding
                                </p>
                            </div>
                            <div class="col-3 header__tabs">
                                <p [class.active]="isRouterLinkActive('/file-upload/upload-history')" (click)="navigateUrl('/file-upload/upload-history')">
                                    Upload History
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div [ngClass]= 'localStorageService.get("authorized") !== null && router.url !=="/faq" ? "col-2" : router.url === "/faq" || localStorageService.get("authorized") === null  ? "col-2 offset-3 offset-md-7"  : "col-2"' class="header__icons text-right ">       
                    <ng-container *ngIf="router.url !== '/otp'">
                        <div *ngIf='router.url !== "/faq"' class="row">
                            <!-- <div *ngIf="localStorageService.get('authorized') !== null" class="d-none d-md-block col-md-4 header__profile">
                                <atram-button remove-component-tag
                                                buttonType="link"
                                                title="Profile"
                                                componentClass="btn-ico"
                                                icon="atram-ico before ico-profile ico-3x ico-active">
                                </atram-button>
                            </div> -->
                            <div [ngClass]= 'localStorageService.get("authorized") === null? "col-md-12" : "text-center d-none d-md-block"'  class="col-6">
                                <atram-button remove-component-tag
                                            buttonType="link"
                                            title="FAQ"
                                            componentClass="btn-ico"
                                            (on-click)="goToFAQ()"
                                            icon="atram-ico before ico-question-mark ico-3x ico-active">
                                </atram-button>
                            </div>
                            <div *ngIf="localStorageService.get('authorized') !== null" class="d-none d-md-block col-md-6 header__logout">
                                <atram-button remove-component-tag
                                                buttonType="link"
                                                title="Logout"
                                                componentClass="btn-ico"
                                                (on-click)="goToSignIn()"
                                                icon="atram-ico before ico-logout ico-3x ico-active">
                                </atram-button>
                            </div>
                        </div>
                        <div *ngIf='router.url === "/faq"' class="row">
                            <atram-button label="Back"
                                          buttonType="default"
                                          componentClass="btn-submit"
                                          (on-click)="goBack()">
                            </atram-button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="localStorageService.get('authorized') !== null" class="hamburger" [class.active]="openNav">
        <div class="hamburger__menu d-block d-md-none col-2" 
            id="sidebar">
            <div class="row">
                <div class="header__logo col-8 col-md-2">       
                    <img src="/assets/images/atram_614x130.png"/>
                </div>
                <div class="hamburger-icon col-2"
                    (click)="onClickHamburger()">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <ul >
                <li>Mutual Funds</li>
                <li>Unit Investment Trust Funds</li>
                <li>Upload History</li>
                <!-- <li>Profile</li> -->
                <li>FAQ</li>
                <li (click)="goToSignIn()">Logout</li>
            </ul>
        </div>
    </div>  
</div>
<atram-modal #atramModal></atram-modal>